import React from 'react';
import { saleSidebarConstants } from '../../Constants';
import { GroupSidebar, IconAgency } from '@esg/ui';

export const SaleSidebar: React.FC = () => {

    return (
        <GroupSidebar
            label='Sales'
            sidebarItems={saleSidebarConstants}
            Icon={<IconAgency.Menu.Sale />}
            border
        />
    );
};
